import React, { Fragment, useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';
import Division from '../../../api/models/division';
import { getDivisions } from '../../../api/services/divisionService';

type ViewState = {
  message?: string;
};

const ViewDivisions = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: (d: any) => d.name ?? '',
        width: '20%'
      },
      {
        Header: 'Description',
        accessor: (d: any) => d.description ?? '',
        width: '66%'
      },
      {
        id: 'active',
        Header: 'Active',
        accessor: (d: any) => (d.isVisible ? 'Active' : 'Inactive'),
        width: '20%'
      },
      {
        accessor: 'divisionId',
        disableSortBy: true,
        Cell: (props: any) => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon
                  className='w-5 h-5 cursor-pointer'
                  aria-hidden='true'
                />
              </span>
            </div>
          );
        },
        className: 'hidden sm:table-cell',
      },
    ],
    []
  );

  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const [divisions, setDivisions] = useState<Division[]>([]);

  const { error, isPending } = useAsync({
    promiseFn: getDivisions,
    onResolve: (r) => {
      const d: Division[] = r.data.divisions;
      setDivisions(d);
    },
  });

  useEffect(() => {
  }, [divisions]);

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={isPending}>
      <Fragment>
        {state?.message && <Notification>{state?.message}</Notification>}

        <div className='mb-4 text-right'>
          <Link className='btn' to='/admin/divisions/new'>
            Add Division
          </Link>
        </div>

        <DataTable
          columns={columns}
          data={divisions}
          showPagination={true}
          getRowProps={(row: any) => ({
            className: row.original.isMyMessage
              ? 'cursor-pointer hover:bg-purple-300 bg-purple-200'
              : 'cursor-pointer hover:bg-gray-100',
            onClick: () => {
              history.push(`/admin/divisions/${row.values.divisionId}`);
            }
          })}
        />
      </Fragment>
    </Layout>
  );
};

export default ViewDivisions;
